import axios, {
  type AxiosInstance,
  type InternalAxiosRequestConfig,
  type AxiosResponse,
  type AxiosError,
} from 'axios'
import { getToken } from '@/utils/auth'
import { useToast } from 'vuestic-ui'

const { init: notify, closeAll } = useToast()

export interface ResponseData<T> {
  code: number | string
  data?: T
  msg: string
}

const service: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API,
  timeout: 10000,
})

// 请求拦截器
service.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    console.error('Request Error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  //@ts-ignore
  (response: AxiosResponse<ResponseData<any>>) => {
    const res = response.data

    if (res instanceof Blob) {
      return Promise.resolve(res)
    }

    if (response.headers['content-type'] === 'application/octet-stream') {
      return Promise.resolve(res)
    }

    const resCode = parseInt(res.code.toString().replace(/([a-zA-Z])/g, ''))
    res.code = resCode

    if (res.code === 401 || res.code === 403 || res.code === 4103) {
      const delay = 2000
      const timer = setTimeout(() => {
        clearTimeout(timer)
        if (location.pathname.startsWith('/cms')) {
          window.location.href = '/cms/login'
        } else {
          window.location.href = '/calculator/login'
        }
      }, delay)
      closeAll()
      notify({ message: '会话已过期, 请重新登录', color: 'danger' })
      return Promise.reject(new Error('会话已过期, 请重新登录'))
    }

    if (res.code !== 0) {
      console.error('Response Error:', res.msg || 'Error')
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return Promise.resolve(res)
    }
  },
  (error: AxiosError) => {
    const status = error.status
    if (status === 401 || status === 403) {
      const delay = 2000
      const timer = setTimeout(() => {
        clearTimeout(timer)
        if (location.pathname.startsWith('/cms')) {
          window.location.href = '/cms/login'
        } else {
          window.location.href = '/calculator/login'
        }
      }, delay)
      closeAll()
      notify({ message: '会话已过期, 请重新登录', color: 'danger' })
      return Promise.reject(new Error('会话已过期, 请重新登录'))
    } else {
      console.error('Response Error:', error.message)
      return Promise.reject(error)
    }
  }
)

export default service
